export default __webpack_public_path__ + "1c53c33c11dae7cc6d9362bd3a918624.ogg";